<template>
    
 
        
     
        
     <div class="case">

         <div class="img-tab" >
                <!-- <el-button type="success" size="large" plain @click="handleChangeP1()" >智能巡检平台</el-button>
                <el-button type="success" size="large" plain @click="handleChangeP2()">无人机巡检</el-button>
                <br>
                <br>
                <br>
                <br> -->
                <div v-show="true">
                    <el-carousel ref="bannerCarousel" style="height: 600px;width:90%;left:5%" :interval="3000" arrow="always" >
                        <el-carousel-item :style="{height:carouselHeight,overflow:'hidden'}">
                          <div :ref="`banner-div-0`" style="background: transparent;">
                            <img style="width: 100%;" src="@/assets/product/011.png" fit="fill" :ref="`banner-img-0`" @load="initDivHeight(0)"/>
                          </div>
                        </el-carousel-item>
                        <el-carousel-item :style="{height:carouselHeight,overflow:'hidden'}">
                          <div :ref="`banner-div-1`" style="background: transparent;">
                            <img style="width: 100%;" src="@/assets/product/03.png" fit="fill" :ref="`banner-img-1`" @load="initDivHeight(1)"/>
                          </div>
                        </el-carousel-item>
                        <el-carousel-item :style="{height:carouselHeight,overflow:'hidden'}">
                          <div :ref="`banner-div-1`" style="background: transparent;">
                            <img style="width: 100%;" src="@/assets/product/04.png" fit="fill" :ref="`banner-img-1`" @load="initDivHeight(1)"/>
                          </div>
                        </el-carousel-item>
                    </el-carousel>
                      <div   style="font-size: 18px;margin-top:50px;">
                      <h2 style="margin-bottom:50px;" >辽宁省高速公路智能巡检平台</h2>

                    
                                  <p>随着辽宁省高速公路网络的不断扩张与交通流量的持续增长，传统的人工巡检方式已难以满足高效、精准管理高速公路路况及设施的需求。</p>
                                  <p>为提升高速公路运营管理的智能化水平，提高工作效率，降低人力成本与安全风险，辽宁省高速公路智能巡检平台应运而生。</p>
                      <h3>项目概述</h3>
                            
                                  <p>本项目构建了一套先进的高速公路智能巡检平台，整合了前端 Vue 技术、后端 Java 语言以及中间件 Redis，借助密布于高速公路的摄像头</p>
                                  <p>对道路路况与护栏实况进行 24 小时不间断监测。通过智能算法对采集到的海量数据进行深度分析，实现对路况病害（如裂缝、坑洼等）的精</p>
                                  <p>准检测包括病害大小、位置信息，同时能够快速判断护栏是否存在损坏以及损坏的具体位置，从而达成高速公路的智能化管理目标。并且，</p>
                                  <p>平台将分析结果进行可视化大屏展示，以便管理决策人员能够直观、全面地掌握高速公路的实时状况。</p>  
                    
                      <h3>功能模块</h3> 
                      <h4>路况监测与病害检测</h4>  
                                  <p>实时获取摄像头拍摄的道路图像数据。运用智能图像识别算法，对道路路面进行像素级分析，精准识别出裂缝、坑洼、车辙等各类病害。</p>  
                                  <p>计算病害的面积、长度、深度等量化指标，并精确定位病害在高速公路上的具体位置（车道、里程桩号等）。根据预设的病害分级标准，</p>
                                  <p>对检测到的病害进行严重程度分级，为后续的养护决策提供科学依据。</p>
                      <h4>护栏监测与损坏识别</h4>  
                                  <p>分析摄像头捕捉的护栏图像，检测护栏是否存在变形、缺失、倾斜等损坏情况。确定损坏护栏的具体位置信息，便于快速派遣维修人员进</p>
                                  <p>行修复作业。建立护栏状态数据库，对护栏的历史损坏情况与维修记录进行跟踪管理，以便进行维护周期分析与质量评估。</p>
                      <h4>数据可视化与报表生成</h4>
                                  <p>将路况病害数据、护栏状况数据以直观的图表形式（如地图分布、柱状图、折线图等）展示在前端界面，方便管理人员快速了解整体情况</p>
                                  <p>与趋势变化。按照不同时间段（日、周、月、年）、不同路段等维度生成详细的巡检报告，报告内容包括病害统计数量、类型分布、护栏</p>
                                  <p>损坏情况汇总等信息，为高速公路管理部门的决策制定提供数据支持。</p>
                      <h4>预警与通知系统</h4>
                                  <p>当检测到严重路况病害或大量护栏损坏等异常情况时，平台自动触发预警机制。通过短信、邮件等多种方式向相关管理人员发送预警信息</p>
                                  <p>确保及时采取应对措施，保障高速公路的安全畅通。</p>
                      <h4>可视化大屏展示</h4>
                                  <p>设计专门的可视化大屏页面，布局合理、简洁大气，能够适应监控中心等场所的展示需求。在大屏上集中呈现高速公路的关键信息，如实</p>
                                  <p>时路况概览（以地图形式展示不同路段的拥堵、畅通情况）、病害热点分布（通过热力图直观显示病害集中区域）护栏损坏汇总（以图表</p>
                                  <p>展示不同类型护栏损坏数量及位置分布）、交通流量动态（实时流量曲线及高峰时段分析）等。采用动态更新机制，确保大屏数据与实际</p>
                                  <p>情况同步，数据更新频率可根据需求灵活设置，让管理人员能够第一时间掌握高速公路的最新态势，以便迅速做出指挥调度决策。</p>
                      <h3>项目优势</h3> 
                                    <div style="display: flex;justify-content:center"> 
                                      <p style="font-weight: bold;">智能化程度高:</p>
                                      <p>利用先进的智能算法，实现了对路况与护栏的自动监测与分析，减少了人工干预，提高了检测的准确性与效率。</p>
                                  </div>
                                  <div style="display: flex;justify-content:center">
                                      <p style="font-weight: bold;">实时性强:</p>
                                      <p>借助高速网络与高效的数据处理技术，能够实时获取并处理摄像头数据，及时发现问题并发出预警，有效降低安全事故风险。</p>  
                                  </div>
                                  <div style="display: flex;justify-content:center">
                                      <p style="font-weight: bold;">数据整合与共享:</p>
                                      <p>通过与其他高速公路管理系统的数据交互，实现了数据的整合与共享，打破了信息孤岛，为多部门协同工作提供了便利。</p>  
                                  </div>
                                  <div style="display: flex;justify-content:center">
                                      <p style="font-weight: bold;">提升管理效率:</p>
                                      <p>自动化的巡检与数据分析流程，大大缩短了传统人工巡检的周期，提高了高速公路养护与管理的工作效率，降低了运营成本。</p>  
                                  </div>
                                  <div style="display: flex;justify-content:center">
                                      <p style="font-weight: bold;">直观决策支持:</p>
                                      <p>可视化大屏展示将复杂的数据转化为直观易懂的图形界面，为管理决策人员提供了一目了然的信息呈现，有助于快速、精准地制定管理策略与调度方案。</p>
                                      <br>
                                      <br>
                                      <br>
                                      <br> <br> <br> <br> <br>
                                      <br>
                                      <br>
                                  </div>
                                
                                <div></div>
                    
                        </div>
                </div>
                <!-- <div v-show="isShowP2">
                    <p>无人机</p>
                    <el-carousel ref="bannerCarousel" style="height: 600px;width:90%;left:5%" :interval="3000" arrow="always" >
                        <el-carousel-item :style="{height:carouselHeight,overflow:'hidden'}">
                          <div :ref="`banner-div-0`" style="background: transparent;">
                            <img style="width: 100%;transform: scale(0.9)"  src="@/assets/product/98.png" fit="fill" :ref="`banner-img-0`" @load="initDivHeight(0)"/>
                          </div>
                        </el-carousel-item>
                        <el-carousel-item :style="{height:carouselHeight,overflow:'hidden'}">
                          <div :ref="`banner-div-1`" style="background: transparent;">
                            <img style="width: 100%;transform: scale(0.9)" src="@/assets/service/93.png" fit="fill" :ref="`banner-img-1`" @load="initDivHeight(1)"/>
                          </div>
                        </el-carousel-item>
                        <el-carousel-item :style="{height:carouselHeight,overflow:'hidden'}">
                          <div :ref="`banner-div-1`" style="background: transparent;">
                            <img style="width: 100%;transform: scale(0.9);  " src="@/assets/product/95.png" fit="fill" :ref="`banner-img-1`" @load="initDivHeight(1)"/>
                          </div>
                        </el-carousel-item>
                    </el-carousel>
                </div> -->
  
          </div>
  
    
  
 
    </div>
   
  </template>
  
  <script>
  export default {
    name: 'product',
    components: {
    },
    data(){
      return{
        types:[],
        carouselHeight:'600px',
        isShowP1:true,
        isShowP2:false,
      }
    },
    methods:{
        handleChangeP2(){
              this.isShowP1=false;
             this.isShowP2=true;
        },
        handleChangeP1(){
            this.isShowP1=true;
            this.isShowP2=false;
        },
         
    //   //跳转页面
    //   jump(child){
    //     this.$router.push({ name: 'caseDetails', query: { id:child.id }});
    //   },
    //   // 注意不能直接在获取到数据后调用此函数，使用nextTick也不行，因为图片会先加载，但是宽高还未计算出来
    //   calcDivHeight(targetIndex) {
    //     let targetDivRef = this.$refs[`banner-div-${targetIndex}`]
    //     this.carouselHeight = targetDivRef.offsetHeight + 'px'
    //   },
    //   // 控制banner高度，适应图片
    //    initDivHeight(index){
    //      this.calcDivHeight(index);
    //      this.bannerAutoPlay = true;
    //    },
    //   //获取案例分类
    //    getTypes(){
    //      this.$apis.baseData.getClazz({pcode:'AL'}).then(res=>{
    //       this.types=res.data.list||[]
    //        if(this.types.length){
    //          for(let item of this.types){
    //            this.$set(item,'data',[])
    //            this.getTypesNext(item)
    //          }
    //        }
    //      })
    //    },
    //   //获取案例分类下的数据
    //   getTypesNext(item){
    //      this.$apis.baseData.getPage({clazzCode:item.code,pageNum: 1, pageSize: this.titleType==2?1:3}).then(res=>{
    //        item.data=res.data.list||[]
    //     })
    //    },
    //   startWatchingWidth() {
    //     if(this.$refs.home.offsetWidth&&this.$refs.home.offsetWidth<=768){
    //       this.titleType=2
    //     }
    },
    mounted(){
    //     this.startWatchingWidth()
    //    this.getTypes()
    //    this.initDivHeight(0)
    }
  }

  </script>
  
  <style lang="scss" scoped>
  .case{
    justify-content: flex-start;
    // justify-content: center;
    text-align: center;
    width:100%;
    height:100%;
    display:flex;
    align-content: center;
    flex-direction: column;
    background: #fff;
   
  }
  .product_head{
  
    // align-items: center;
    height: 500px;
    width:100%;
  }


  
  .el-carousel{
    width: 100%;
   
  }
  </style>
  